import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tag.scss';
import Tag from './Tag';
import {getFeatureFlag} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/featureFlags';

export const Tags = ({tags, includeTag, excludeTag}) => {
    if (getFeatureFlag('majorStoryToggle')) {
        tags = tags.filter(tag => !(tag.dimension === 'Display' && tag.name === 'Major Story'));
    }
    const toggleIncluded = tag => () => (tag.included ? excludeTag(tag) : includeTag(tag));

    return (
        <ul className={styles.Tags}>
            {tags
                .map(tag => (
                    <li className={styles.item} key={tag.dimension + tag.name}>
                        <Tag tag={tag} onChange={toggleIncluded(tag)} />
                    </li>
                ))}
        </ul>
    );
};
Tags.propTypes = {
    tags: PropTypes.array,
    includeTag: PropTypes.func,
    excludeTag: PropTypes.func,
};

export default Tags;
